import { ConsumptionOmieActions, EConsumptionOmieActions } from "@edp-store/actions/consumption-omie.actions";
import { IConsumptionOmieState, initialOmieState } from "@edp-store/state/consumption-omie.state";

export function consumptionOmieReducers(state = initialOmieState, action: ConsumptionOmieActions): IConsumptionOmieState {
    switch (action.type) {
        case EConsumptionOmieActions.SetOmieConsumption: {
            return {
                ...state,
                consumptionOmie: action.payload,
            };
        }
        case EConsumptionOmieActions.SetOmieWeeklyAverage: {
            return {
                ...state,
                omieWeeklyAverage: action.payload,
            };
        }
        case EConsumptionOmieActions.SetOmiePrice: {
            return {
                ...state,
                omiePrice: action.payload,
            };
        }
        default:
            return state;
    }
}
